module.exports = __webpack_public_path__ + "static/img/compass.14e4e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/compass.png
// module id = zfYK
// module chunks = 4